import { UUID } from '@/plugins/common'
import Condition from './condition'
import Notice from './notice'
import _ from 'lodash'

export default class Connection {
  id = ''
  // 源节点
  sourceNodeId = ''
  // 目标节点
  targetNodeId = ''
  // 操作类型
  operationType = ''
  // 操作按钮
  actionId = ''
  // 是否默认线
  defaultLine = false
  // 定时
  timing = {
    isTiming: '0',
    hour: '',
    minute: '',
    second: ''
  }
  // 线上的条件关系
  conditionRelation=true
  // 条件
  conditions = []

  // 通知
  notice = []

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    args.id = '_' + UUID.create()
    if (!args.defaultLine) {
      args.defaultLine = false
    }
    let connection = new Connection(args)
    let notice = Notice.create({targetNode: args.targetNodeId ? [args.targetNodeId] : []})
    connection.notice.push(notice)
    return connection
  }

  static load (args) {
    args.timing = JSON.parse(args.timing)
    args.notice.forEach(m => {
      m = Notice.load(m)
    })
    let connection = new Connection(args)
    if (args.conditions && args.conditions.length !== 0) {
      let conditions = []
      args.conditions.forEach(m => {
        conditions.push(Condition.load(m))
      })
      connection.connections = conditions
    }

    return connection
  }

  addCondition () {
    let condition = Condition.create({})
    this.conditions.push(condition)
  }
  delCondition (conditionId) {
    let index = this.conditions.findIndex(m => m.id === conditionId)
    if (index || index === 0) {
      this.conditions.splice(index, 1)
    } else {
      throw new Error('未找到该流转线')
    }
  }

  // 获取当前节点的祖先节点
  getAncestors (nodeId) {
    let paths = this.getPaths(nodeId)
    let nodeIds = []
    if (paths.length !== 0) {
      nodeIds = paths[0].split('->')
      // 按照最短路径原则
      paths.forEach(m => {
        if (m.split('->').length < nodeIds.length) {
          nodeIds = m.split('->')
        }
      })
    }
    return nodeIds
  }
}



// WEBPACK FOOTER //
// ./src/store/process/connection.js